module.exports = __webpack_public_path__ + "static/media/4.907e0d56.jpeg";